// extracted by mini-css-extract-plugin
module.exports = {"footnoteContainer":"FootnoteText_footnoteContainer__2GrJa","text":"FootnoteText_text__o_c03","header":"FootnoteText_header__M_Q2C"};